module.exports = __webpack_public_path__ + "img/71.9.TU.92bbedb2.png";